import { atom } from 'jotai';

import { jsonHelpers } from '../json';

export const createAtomWithStorage = <T extends string | number | boolean | object | null | undefined>(
    key: string,
    initialValue: T
) => {
    const getInitialValue = () => {
        const item = localStorage.getItem(key);

        if (item === null) {
            return initialValue;
        }

        return jsonHelpers.safeParse(item, initialValue);
    };

    const baseAtom = atom(getInitialValue());

    const derivedAtom = atom(
        (get) => get(baseAtom),
        (get, set, update: T | ((value: T) => T)) => {
            const nextValue = typeof update === 'function' ? update(get(baseAtom)) : update;

            set(baseAtom, nextValue);
            localStorage.setItem(key, jsonHelpers.safeStringify(nextValue));
        }
    );

    return derivedAtom;
};
